export const hideNull = (value?: unknown): string => {
  if (value === null || value === undefined) return 'n/a';

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};
